import React from 'react';
import {
  Bar,
  BarChart as RechartsBarChart,
  CartesianGrid,
  ResponsiveContainer,
  Tooltip,
  XAxis,
  YAxis,
} from 'recharts';
import { CHART_COLOR } from '@/features/ai-agents/chat/MarkdownTableVisualization/constants';
import { TruncatedXAxisTick } from '@/features/ai-agents/chat/MarkdownTableVisualization/helpers';
import {
  ChartRow,
  ChartValueFormatter,
} from '@/features/ai-agents/chat/MarkdownTableVisualization/types';
import { sortChartRowsByDate } from '@/features/ai-agents/chat/MarkdownTableVisualization/utils';

interface BarChartProps {
  data: ChartRow[];
  formatValue: ChartValueFormatter;
  valueLabel: string;
}

export function BarChart({ data, formatValue, valueLabel }: BarChartProps) {
  const chartData = sortChartRowsByDate(data);

  return (
    <ResponsiveContainer width="100%" height={300}>
      <RechartsBarChart
        data={chartData}
        margin={{ top: 12, right: 20, bottom: 8, left: 0 }}
      >
        <CartesianGrid stroke="#e5e7eb" strokeDasharray="3 3" />
        <XAxis
          dataKey="x"
          tick={<TruncatedXAxisTick centered />}
          interval={0}
          height={72}
        />
        <YAxis tickFormatter={formatValue} />
        <Tooltip formatter={formatValue} />
        <Bar
          dataKey="y"
          name={valueLabel}
          fill={CHART_COLOR}
          radius={[3, 3, 0, 0]}
          isAnimationActive={false}
        />
      </RechartsBarChart>
    </ResponsiveContainer>
  );
}
